import React, { FC } from 'react'
import { ProgressBar } from './ProgressBar'
import { Rating } from './Rating'

/**
 * 打分组件 Ranting
 * value range：1 ≤ value ≤ length
 */
// eslint-disable-next-line import/prefer-default-export
export const RatingBox: FC<{
  reviewAverage?: number
  reviewList: any[]
  reviewFigure: any
  showPercentBox?: boolean
  preRight?: string
}> = ({
  reviewAverage = 0,
  reviewList,
  reviewFigure = '',
  showPercentBox = false,
  preRight = 'pl-14',
}) =>
  showPercentBox ? (
    <>
      <div className="flex sm:flex-nowrap md:flex-wrap flex-wrap items-center pl-4 py-4">
        <div className="text-32px font-semibold">
          {(
            reviewAverage ||
            (reviewList.length
              ? reviewList.map((i) => i.rating).reduce((a, b) => a + b) /
                reviewList.length
              : 0)
          ).toFixed(1) || 0}
        </div>
        {/* 星级显示规则（产品确定的）:     */}
        {/* 1星：    1-1.5分(不包含1.5)   */}
        {/* 1.5星：  1.5-2分(不包含2)     */}
        {/* 2星：    2-2.5分(不包含2.5)   */}
        {/* 2.5星：  2.5-3分(不包含3)     */}
        {/* 3星：    3-3.5分(不包含3.5)   */}
        {/* 3.5星：  3.5-4 (不包含4)      */}
        {/* 4星：    4-4.5分(不包含4.5)   */}
        {/* 4.5星：  4.5-4.8分(不包含4.8) */}
        {/* 5星：    4.8-5分(包含5)       */}
        <Rating
          type="outline"
          value={
            (
              reviewAverage ||
              (reviewList.length
                ? reviewList.map((i) => i.rating).reduce((a, b) => a + b) /
                  reviewList.length
                : 0)
            ).toFixed(1) || 0
          }
          length={5}
          openHalf
          func={(v: number) => Math[v < 4.8 ? 'floor' : 'ceil'](v * 2) / 2}
          className="star-sm flex flex-nowrap sm:pl-3 md:pl-0 pl-0 my-1"
        />
      </div>
      <div className={`flex flex-wrap pr-4 py-3.5 ${preRight}`}>
        <div className="my-0.5 text-xs text-gray-400">
          How did the item fit?
        </div>
        <div className="w-full flex items-center text-xs text-black">
          <div className="w-20 -mr-0.5">Small</div>
          <ProgressBar percent={reviewFigure.smPer} className="h-2 flex-grow" />
          <div className="w-7 my-0.5 ml-2 text-12">{reviewFigure.smPer}%</div>
        </div>
        <div className="w-full flex items-center text-xs text-black">
          <div className="w-20 -mr-0.5">True to size</div>
          <ProgressBar
            percent={reviewFigure.truePer}
            className="h-2 flex-grow"
          />
          <div className="w-7 my-0.5 ml-2 text-12">{reviewFigure.truePer}%</div>
        </div>
        <div className="w-full flex items-center text-xs text-black">
          <div className="w-20 -mr-0.5">Large</div>
          <ProgressBar percent={reviewFigure.lgPer} className="h-2 flex-grow" />
          <div className="w-7 my-0.5 ml-2 text-12">{reviewFigure.lgPer}%</div>
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="py-5 pl-6 text-32px font-semibold">
        {(
          reviewAverage ||
          (reviewList.length
            ? reviewList.map((i) => i.rating).reduce((a, b) => a + b) /
              reviewList.length
            : 0)
        ).toFixed(1) || 0}
      </div>
      <Rating
        type="outline"
        value={
          (
            reviewAverage ||
            (reviewList.length
              ? reviewList.map((i) => i.rating).reduce((a, b) => a + b) /
                reviewList.length
              : 0)
          ).toFixed(1) || 0
        }
        length={5}
        openHalf
        func={(v: number) => Math[v < 4.8 ? 'floor' : 'ceil'](v * 2) / 2}
        className="py-5 pr-6"
      />
    </>
  )
